// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"615": "home","671": "budgetDetails","929": "budgetList",}[chunkId] || chunkId) + "." + {"242": "af21f222e7d0310e","356": "985926d76a504cd9","594": "ca52ed6b6479a147","615": "20937db968406cf4","671": "528948a92c99bb0b","929": "f3046866e6756267","996": "091e698167a7b207",}[chunkId] + ".js"
}